import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import HotelItineraryContent from './HotelItineraryContent';
import getHotelPriceDisplayPreference from '../../../../helpers/selectors/getHotelPriceDisplayPreference';
import { useNLPConstants, useNLPInstructions, useNLPRelevantTerms } from '../../../ChatGPTInterface/constants/nlpSettings';
import checkDoShowMarkupRates from '../../../../helpers/selectors/checkDoShowMarkupRates';
import { TravelTypes } from '../../../../constants';
import { checkDoShowAgentCommission } from '../../../../store/slices/user';

const HotelItinerary = ({
  itinerary, tripId, onModalClose, isInsideModal, isExpanded, onMouseEnter, onMouseLeave,
  doShowPrice, doScrollToHotel, doHaveBorderAround, wrapperClassName,
  isHotelSelected, doShowChatGpt, travelOption, tripRoomSearchInput,
}) => {
  const { travelAgency } = useSelector((state) => state.user);
  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  const pricingPreference = useSelector(getHotelPriceDisplayPreference());
  const doShowMarkupRates = useSelector(checkDoShowMarkupRates({
    mode: TravelTypes.hotel, tripId,
  }));
  const settings = travelAgency && travelAgency.settings;
  const doCleanseAmenities = settings && settings.cleanseAmenities;
  const doShowHotelSourceInHotelName = settings && settings.doShowHotelSourceInHotelName;

  // Get NLP related settings
  const nlpConstants = useNLPConstants();
  const nlpRelevantTerms = useNLPRelevantTerms();
  const nlpInstructions = useNLPInstructions();

  return (
    <HotelItineraryContent
      itinerary={itinerary}
      tripId={tripId}
      onModalClose={onModalClose}
      isInsideModal={isInsideModal}
      isExpanded={isExpanded}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      doShowPrice={doShowPrice}
      doScrollToHotel={doScrollToHotel}
      doShowAgentCommission={doShowAgentCommission}
      doHaveBorderAround={doHaveBorderAround}
      wrapperClassName={wrapperClassName}
      isHotelSelected={isHotelSelected}
      pricingPreference={pricingPreference}
      doShowChatGpt={doShowChatGpt}
      nlpConstants={nlpConstants}
      nlpRelevantTerms={nlpRelevantTerms}
      nlpInstructions={nlpInstructions}
      doShowMarkupRates={doShowMarkupRates}
      doShowHotelSourceInHotelName={!settings || doShowHotelSourceInHotelName}
      doCleanseAmenities={doCleanseAmenities}
      travelOption={travelOption}
      tripRoomSearchInput={tripRoomSearchInput}
    />
  );
};

HotelItinerary.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string,
  onModalClose: PropTypes.func,
  doShowPrice: PropTypes.bool,
  isInsideModal: PropTypes.bool,
  isExpanded: PropTypes.shape({
    value: PropTypes.bool,
  }),
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  doScrollToHotel: PropTypes.bool,
  doHaveBorderAround: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  isHotelSelected: PropTypes.bool,
  doShowChatGpt: PropTypes.bool,
  travelOption: PropTypes.shape({
    key: PropTypes.string,
    mode: PropTypes.number,
  }),
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

HotelItinerary.defaultProps = {
  isInsideModal: false,
  tripId: '',
  onModalClose: undefined,
  doShowPrice: true,
  isExpanded: { value: false },
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  doScrollToHotel: true,
  doHaveBorderAround: true,
  wrapperClassName: 'my-3 rounded-lg',
  isHotelSelected: false,
  doShowChatGpt: true,
  travelOption: undefined,
  tripRoomSearchInput: undefined,
};

export default React.memo(HotelItinerary);
